import { createActions } from 'redux-actions'

const { changeModalState, resetAllModals } = createActions({
  CHANGE_MODAL_STATE: modalState => modalState,
  RESET_ALL_MODALS: () => {}
})

export { changeModalState, resetAllModals }
